
@if (strains != null) {
  <mat-form-field>
    <mat-label>Strain</mat-label>
    <mat-select [disabled]="disabled" [(ngModel)]="strain">
      @for (strain of strains; track strain) {
        <mat-option [value]="strain">{{strain.name}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}